  <template>
  <div class="page">
    <header></header>
    <div class="content">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="getRechargeList"
      >
        <div class="item-list" v-for="(item, index) in rechargeList" :key="index">
          <div class="item"><span>充值卡号：</span><span>{{item.icNo}}</span></div>
          <div class="item"><span>所属代理商：</span><span>{{item.vipUserNickName}}</span></div>
          <div class="item"><span>充值次数：</span><span>{{item.addTimes}}次</span></div>
          <div class="item"><span>充值类型：</span><span>{{item.rechargeType == 1 ? "周期卡" : "商务卡"}}</span></div>
          <div class="item"><span>充值时间：</span><span>{{item.createTime}}</span></div>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
import API from "../utils/api";

export default {
  data() {
    return {
      rechargeList: [],
      loading: false,
      finished: false,
      page: 1,
      pageSize: 1,
    };
  },
  watch: {},
  computed: {},
  methods: {
    getRechargeList() {
      if(!this.finished){
        this.$get(`${API.rechargeInfo}?icCard=${sessionStorage.getItem("card")}`)
          .then((res) => {
            if (res.code == 200) {
              this.rechargeList = res.data.rows
              this.finished = true
              this.loading = true
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
  },
  created() {},
  mounted() {
    // this.getRechargeList();
  },
};
</script>
<style scoped>
header{
  width: 100%;
  height: 180px;
  background: url(/static/img/bg.png)no-repeat top;
  background-size: 100% 100%;
}
.content{
  margin-top: -14%;
  position: relative;
  z-index: -1;
  margin-left: 15px;
  margin-right: 15px;
}
.van-list .item-list{
  padding: 65px 15px 20px
}
.van-list .item{
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: .4rem;
}
</style>


// WEBPACK FOOTER //
// src/pages/recharge.vue